export const correction = {
  Washington: -7,
  London: 0,
  Berlin: 1,
  Paris: 2,
  Moskow: 3,
  Abu_Dhabi: 4,
  Islamabad: 5,
  Astana: 6,
  Hanoi: 7,
  Beijing: 8,
  Tokyo: 9,
  Port_Moresby:10,
  Sydney: 11 
}
